// extracted by mini-css-extract-plugin
module.exports = {"container":"SectionState_container__CE1_g","title":"SectionState_title__FyXdd"};